import * as types from "./mutation-type";
import { getRequestAccrualsQuery } from "./queries.graphql";
import gqlClient from "@/modules/graphql";

const actions = {
  async getRequestAccrualTemplates({ commit }, variables = {}) {
    try {
      commit(types.GET_REQUEST_ACCRUAL_TEMPLATES_BEGIN);
      const {
        data: {
          data: {
            company: { requestAccrualTemplates 
            }
          }
        }
      } = await gqlClient.query({
        query     : getRequestAccrualsQuery,
        variables : variables
      });
      commit(types.GET_REQUEST_ACCRUAL_TEMPLATES_SUCCESS, requestAccrualTemplates);
    } catch (e) {
      commit(types.GET_REQUEST_ACCRUAL_TEMPLATES_ERROR, e);
    }
  },
 
};

export default actions;